import { render, staticRenderFns } from "./RowAction.vue?vue&type=template&id=202e068a&scoped=true"
import script from "./RowAction.vue?vue&type=script&setup=true&lang=ts"
export * from "./RowAction.vue?vue&type=script&setup=true&lang=ts"
import style0 from "./RowAction.vue?vue&type=style&index=0&id=202e068a&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "202e068a",
  null
  
)

export default component.exports